import classNames from "classnames";
import React, { type AnchorHTMLAttributes } from "react";
import { type LinkProps, Link as ReactLink, useLocation } from "react-router-dom";

import { useLayoutStore } from "@store/layout";

interface IProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  as?: "text" | "wrapper" | "square";
  variant?: "primary" | "secondary";
  to?: LinkProps["to"];
  state?: LinkProps["state"];
  isActive?: boolean;
}

export default function Link({ className, children, as = "wrapper", variant = "primary", href = "", isActive = true, ...props }: IProps) {
  const { pathname } = useLocation();

  const { closeAll } = useLayoutStore();

  const isExternalLink = href.includes("https://");

  const linkStyle = classNames(
    "inline-block cursor-pointer hover:text-black dark:hover:text-white",
    !isActive && "text-dark-grey hover:text-black dark:hover:text-white",
    as === "square" && [
      "items-center pc:h-8.75 h-10 px-3 py-1.5 w-fit text-ko",
      variant === "primary" && "bg-black text-white disabled:bg-grey dark:bg-white dark:text-black hover:text-white",
      variant === "secondary" && "border border-solid flex! border-grey  disabled:border-grey dark:border-dark-grey",
    ],
    className,
  );

  return (
    <>
      {isExternalLink ? (
        <a className={linkStyle} href={href} rel="noopener" target="_blank" {...props}>
          {children}
        </a>
      ) : (
        <ReactLink
          className={linkStyle}
          to={href}
          {...props}
          onClick={(e) => {
            if (pathname.replaceAll("/", "") === href.replaceAll("/", "")) {
              window.scrollTo(0, 0);
              closeAll();
            }
            props?.onClick?.(e);
          }}
        >
          {children}
        </ReactLink>
      )}
    </>
  );
}
